import { css } from '@linaria/atomic';

export const dropdownInputContainer = css`
  width: 100%;
  margin: 0;
`;

export const dropdownInputHidden = css`
  width: 100%;
  height: 100%;
  cursor: default;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
`;
